import { Routes, RouterModule } from '@angular/router';
import { ProviderComponent } from './provider.main';

export const routes: Routes = [
    { path: 'page/provider', component: ProviderComponent },
];

export const PROVIDER_ROUTER = RouterModule.forRoot(routes);
